import React from 'react';
import BlogList from '../components/blog/BlogList';

const BlogsPage = () => {
  return (
    <div className="min-h-screen bg-gray-900">
      <BlogList />
    </div>
  );
};

export default BlogsPage;